import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamGreenSection',
  props: {
    indicator: null,
    text: null,
    color: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})